module.exports = "/assets/e713732e6c69becd151bfca478eec7e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/CE.png
// module id = 1262
// module chunks = 0